import { Cookie } from '../helpers/cookie'
import { spread } from '../helpers/spread'
import { URI } from '../helpers/URI'
import WebModel from '../models/WebModel'

export const SESSION_COOKIE_KEY = 'mediavine_session'
export const DIRECT_KEY = 'DIRECT'

export class Session {
  static cookie: Cookie<Session> = new Cookie(SESSION_COOKIE_KEY, 1)
  depth = 0
  referrer = ''

  constructor() {
    const values = Session.cookie.value || {}
    spread(values).onto(this)
    this.referrer = this.referrer || this.getReferrer()
    this.depth++
    Session.cookie.set(this)
  }

  getReferrer({
    referrer = document.referrer,
    hostname = document.location.hostname
  } = getReferrerDefaults): string {
    const referrerHostname = URI.getHost(referrer)
    if (referrerHostname === '' || referrerHostname === hostname) {
      return DIRECT_KEY
    }

    const majorSocialMatch = getMajorSocialMatch(referrerHostname)
    if (majorSocialMatch) {
      return majorSocialMatch
    }
    const mappedRef = referralMap[referrerHostname]

    return mappedRef ? mappedRef : referrerHostname
  }
}

export interface IGetReferrerParams {
  referrer: string
  hostname: string
}

const getReferrerDefaults = {
  referrer: document.referrer,
  hostname: document.location.hostname
}

export const majorSources = [
  'google',
  'facebook',
  'instagram',
  'pinterest',
  'twitter',
  'yahoo',
  'bing',
  'duckduckgo'
]

const referralMap = {
  't.co': 'twitter',
  'duckduckgo.com': 'duckduckgo'
}

export function getMajorSocialMatch(url: string): string | undefined {
  return majorSources.find((o) => new RegExp(o).test(url))
}

export default new Session()
